import type { OpenImRawMessage } from '../appDto/types';

/** Android `TgImOpenImMessageEditOps.CUSTOM_TYPE_MESSAGE_EDIT`. */
export const TGIM_CUSTOM_TYPE_MESSAGE_EDIT = 'tgim_message_edit';

export type TgimMessageEditNotification = {
  clientMsgId: string;
  text: string;
};

function tryParseJsonObject(raw: string): Record<string, unknown> | undefined {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('{')) return undefined;
  try {
    const parsed = JSON.parse(trimmed) as unknown;
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    // ignore
  }
  return undefined;
}

function parseCustomPayload(raw: OpenImRawMessage): Record<string, unknown> | undefined {
  const custom = (raw as { customElem?: { data?: unknown } }).customElem;
  if (custom?.data) {
    if (typeof custom.data === 'string') {
      const parsed = tryParseJsonObject(custom.data);
      if (parsed) return parsed;
    } else if (typeof custom.data === 'object' && !Array.isArray(custom.data)) {
      return custom.data as Record<string, unknown>;
    }
  }
  if (typeof raw.content === 'string') {
    const root = tryParseJsonObject(raw.content);
    if (!root) return undefined;
    if (typeof root.data === 'string') {
      const nested = tryParseJsonObject(root.data);
      if (nested) return nested;
    }
    if (root.customType) return root;
  }
  return undefined;
}

/**
 * Android `tryConsumeEditNotificationJson`: contentType 110 + customType tgim_message_edit.
 * Returns undefined for non-edit custom messages (including RTC).
 */
export function parseTgimMessageEditNotification(
  raw: OpenImRawMessage,
): TgimMessageEditNotification | undefined {
  const contentType = Number(raw.contentType) || 0;
  if (contentType !== 110) return undefined;
  const payload = parseCustomPayload(raw);
  if (!payload) return undefined;
  if (payload.customType !== TGIM_CUSTOM_TYPE_MESSAGE_EDIT) return undefined;
  const clientMsgId = String(payload.clientMsgID || payload.client_msg_id || '').trim();
  const text = String(payload.text || '').trim();
  if (!clientMsgId || !text) return undefined;
  return { clientMsgId, text };
}
